<template>
  <div v-if="visible">
    <div class="dim">
      <div class="modal" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel">이동경로 선택</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                      @click="close()"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
              <table class="table table-hover table-bordered">
                <tr>
                  <th class="txt-center">
                    <button @click="getPrograms(1)" class="btn btn-dark w-30" :class="{disabled: !this.isProgram}">프로그램</button>
                    <button @click="getBizcards(1)" class="btn btn-dark w-30 ml-1" :class="{disabled: !this.isBizcard}">비즈영어</button>
                    <button @click="getNotices(1)" class="btn btn-dark w-30 ml-1" :class="{disabled: !this.isNotice}">공지사항</button>
                  </th>
                </tr>
              </table>
              <div style="height: 500px; overflow-y: auto">
                <table class="table table-hover table-bordered mt-30 text-center">
                  <tr>
                    <th style="width: 10%">No</th>
                    <th>이름</th>
                    <th style="width: 10%">선택</th>
                  </tr>
                  <tr v-for="(item, index) in items" :key="item.idx">
                    <td>{{ items.length - index }}</td>
                    <td v-if="isProgram">{{ item.programName }}</td>
                    <td v-if="isBizcard">{{ item.title }}</td>
                    <td v-if="isNotice">{{ item.title }}</td>
                    <td>
                      <button @click="postLocationIdx(item.idx)" class="btn btn-outline-dark">선택</button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div v-if="lastpage !== 0" style="padding-left:40%; padding-top:20px;">
              <paginate
                  :page-count="lastpage"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-link'">
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';

export default {
  name: 'tutorModal',
  components: {
    Paginate,
  },
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false
    },
  },

  data: () => ({
    category: {},
    filter: {
      page: 1,
      isUse: 'Y',
    },
    programs: {},
    bizcards: {},
    notices: {},
    items: {},
    lastpage: 1,

    isProgram: false,
    isBizcard: false,
    isNotice: false,
  }),

  watch: {
    visible: function (newVal) {
      this.visible = newVal === true;
    }
  },

  mounted() {
    this.getPrograms(1);
  },

  methods: {
    close() {
      this.$emit("close", false);
    },

    clickCallback: function (pageNum) {
      if(this.isProgram !== false) this.getPrograms(pageNum);
      else if(this.isNotice !== false) this.getNotices(pageNum);
      else if(this.isBizcard !== false) this.getBizcards(pageNum);
    },

    getPrograms: function (page) {
      this.isProgram = true;
      this.isBizcard = false;
      this.isNotice = false;

      if (page !== undefined) {
        this.filter.page = page;
      }
      var params = {
        isUse: (this.filter.isUse === '') ? null : this.filter.isUse,
        status: (this.filter.status === '') ? null : this.filter.status,
        page: this.filter.page,
      };

      this.axios.get(this.$store.state.host + "/v1/admin/programs", {params})
      .then((res) => {
        if (res.data.status === 105) {
          this.programs = [];
          this.lastpage = 0;
        } else {
          this.items = res.data.result.value;
          this.lastpage = res.data.result.lastPage;
        }
      });
    },

    getBizcards: function (page) {
      this.isProgram = false;
      this.isBizcard = true;
      this.isNotice = false;

      if(page !== undefined) this.filter.page = page;
      const url = this.$store.state.host + "/v1/admin/bizcards";
      var params = {
        page: this.filter.page
      };

      this.axios.get(url, {params})
      .then((res) => {
        this.items = res.data.result.value;
        this.lastpage = res.data.result.lastPage;
      });
    },

    getNotices: function (page) {
      this.isProgram = false;
      this.isBizcard = false;
      this.isNotice = true;

      const url = this.$store.state.host + "/v1/admin/notices";
      var params = {
        page: (page === '' ? null : page)
      };

      this.axios.get(url, {
        params
      })
      .then((res) => {
        if (res.data.status === 105) {
          this.notices = [];
          this.lastpage = 0;
        } else {
          this.items = res.data.result.value;
          this.lastpage = res.data.result.lastPage;
        }
      });
    },

    postLocationIdx: function (idx){
      let subject = '';
      if(this.isProgram === true) subject = 'apply';
      else if(this.isBizcard === true) subject = 'biz-cardnews';
      else if(this.isNotice === true) subject = 'notice-view';
      this.$emit('mount', idx, subject);
      this.close();
    }


  }
}
</script>

<style lang="scss" scoped>
.dim {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  z-index: 1000;
}


.modal {
  display: block;
}
</style>
